import HttpRequest from '@/request'

// 基础项配置 列表

export function getBasicList(params: any) {
  return HttpRequest({
    method: 'get',
    url: '/front/uaa/v1/client/word/page',
    params
  })
}


export function getBasicFilter(params: any) { //筛选条件后俩
  return HttpRequest({
    method: 'get',
    url: `/front/uaa/v1/client/word/keyWord`,
    params
  })
}


export function addBasic(params: any, type: number) {
  const url = `/front/uaa/v1/client/word/`
  return HttpRequest({
    method: type === 2 ? 'put' : 'post',
    url: type === 2 ? `${url}${params.id}` : `${url}`,
    data: params
  })
}

export function getBasicDetail(id: string) {
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionCustOrg/word/${id}`,
  })
}

// 组织管理

export function getOrganizationTree() { // 组织树
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionCustOrg/tree`,
  })
}

export function getOrgRole() { // 新增组织获取角色列表
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/role/client`,
  })
}

export function addOrganization(params: any) { // 新增组织
  const url = '/front/energygov/v1/supervisionCustOrg'
  return HttpRequest({
    method: params.id ? 'put' : 'post',
    url: params.id ? `${url}/${params.id}` : `${url}`,
    data: params
  })
}

export function UpdataOrganization(params: any) { // 更新组织
  return HttpRequest({
    method: 'put',
    url: '/front/supervision/v1/supervisionUserInfo/updateOrgNameByOrgId',
    data:params
  })
}

export function getOrganizationDetail(id: string) { // 获取组织详情
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionCustOrg/${id}`,
  })
}

export function deleteOrganization(id: string) { // 删除组织
  return HttpRequest({
    method: 'delete',
    url: `/front/energygov/v1/supervisionCustOrg/${id}`,
  })
}

export function getPositionTree() { // 职位树
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionCustPosition/tree`,
  })
}


export function addPosition(params: any) { // 新增职位
  const url = '/front/energygov/v1/supervisionCustPosition'
  return HttpRequest({
    method: params.id ? 'put' : 'post',
    url: params.id ? `${url}/${params.id}` : `${url}`,
    data: params
  })
}


export function getPositionDetail(id: string) { // 获取职位详情
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionCustPosition/${id}`,
  })
}

export function deletePosition(id: string) { // 删除职位
  return HttpRequest({
    method: 'delete',
    url: `/front/energygov/v1/supervisionCustPosition/${id}`,
  })
}

// 组织成员列表
export function getRoleList(params: any) {
  return HttpRequest({
    method: 'get',
    url: '/front/energygov/v1/supervisionUserInfo',
    params
  })
}

// 添加 编辑
export function addRoleList(params: any) {
  const url = `/front/energygov/v1/supervisionUserInfo`
  return HttpRequest({
    method: params.id ? 'put' : 'post',
    url: params.id ? `${url}/${params.id}` : `${url}`,
    data: params
  })
}

// 组织成员列表详情
export function getRoleDetail(id: string | undefined) {
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionUserInfo//${id}`,
  })
}


export function deleteRoleList(id: string) { // 组织成员列表删除
  return HttpRequest({
    method: 'delete',
    url: `/front/energygov/v1/supervisionUserInfo/${id}`,
  })
}


// 工作流列表
export function getWorkflowList(params: any) {
  return HttpRequest({
    method: 'get',
    url: '/front/workflow/v1/workflowApproval',
    params
  })
}

// 工作流获取applist
export function getWorkflowAppList() {
  return HttpRequest({
    method: 'get',
    url: '/front/unit/v1/unitClientInstance/byCustIdList'
  })
}
// 工作流获取菜单列表
export function getWorkflowMenu(id: string) {
  return HttpRequest({
    method: 'get',
    url: `/front/uaa/v1/resource/byAppObjIdList?appObjId=${id}`
  })
}
// 工作流获取适用组织
export function getWorkflowOrg() {
  return HttpRequest({
    method: 'get',
    url: `/front/uaa/v1/clientOrg/byCustIdList`
  })
}
// 新增工作流
export function addWorkflow(params: any) {
  const base: string = `/front/workflow/v1/workflowApproval`
  const url = params.id ? `${base}/${params.id}` : base
  return HttpRequest({
    method: params.id ? 'put' : 'post',
    url: url,
    data: params
  })
}
// 工作流详情
export function getWorkflowDetail(id: string) {
  return HttpRequest({
    method: 'get',
    url: `/front/workflow/v1/workflowApproval/${id}`
  })
}
// 工作流列表发布
export function lunchWorkflow(id: string) {
  return HttpRequest({
    method: 'post',
    url: `/front/workflow/v1/workflowApproval/${id}`
  })
}
// 工作流列表发布记录列表
export function lunchWorkflowRecord(id: string) {
  return HttpRequest({
    method: 'get',
    url: `/front/workflow/v1/workflowApproval/releaseRecord/${id}`
  })
}


// 获取模板列表
export function getTempDocList(params: any) {
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionDocumentTemplate`,
    params
  })
}


// 获取模板详情
export function getTempDocInfo(params: any) {
  return HttpRequest({
    method: 'get',
    url: `/front/energygov/v1/supervisionDocumentTemplate/`+params,
  })
}


// 新增模板文件
export function saveTempContent(params: any) {
 
  // const base: string = `/front/workflow/v1/workflowApproval`
  // const url = params.id ? `${base}/${params.id}` : base
  return HttpRequest({
    method: 'post',
    url: '/front/energygov/v1/supervisionDocumentTemplate',
    data: params
  })
}

// 新增模板文件
export function editTempContent(params: any) {
  // const base: string = `/front/workflow/v1/workflowApproval`
  // const url = params.id ? `${base}/${params.id}` : base
  return HttpRequest({
    method: 'put',
    url: '/front/energygov/v1/supervisionDocumentTemplate/'+params.id,
    data: params
  })
}


// 删除模板文件
export function delDocTemp(params: any) {
  // const base: string = `/front/workflow/v1/workflowApproval`
  // const url = params.id ? `${base}/${params.id}` : base
  return HttpRequest({
    method: 'delete',
    url: '/front/energygov/v1/supervisionDocumentTemplate/'+params,
  })
}




